module.exports = __webpack_public_path__ + "static/media/microphone@3x.7281ae6b.png";